import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
import store from '@/store';
export default {
  install(Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl('/notifications')
      .configureLogging(LogLevel.Error)
      .build();

    const userHub = new Vue();
    store.commit('setNotifyBus', userHub);
    Vue.prototype.$userHub = userHub;
    window.$userHub = userHub;

    connection.on('Notify', notification => {
      userHub.$emit('new-notification-added', { notification });
    });

    // if connection closed, reopen it
    let startedPromise = null;
    function start() {
      startedPromise = connection.start()
        .then(() => {
          document.dispatchEvent(
            new CustomEvent('swSiteUp', { isUp: true })
          )
        })
        .catch(err => {
          console.log('Retrying connection to websocket...')
          document.dispatchEvent(
            new CustomEvent('swSiteDown', { isUp: false })
          )
        return new Promise((resolve, reject) =>
          setTimeout(
            () =>
              start()
                .then(resolve)
                .catch(reject),
            10000
          )
        );
      });
      return startedPromise;
    }

    connection.onclose(() => start());

    start();
  }
};
